(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4403],{

/***/ 83081:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgConfirmed = function SvgConfirmed(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M7.5 17.813a1.383 1.383 0 0 0 .601-.178 65.115 65.115 0 0 0 3.228-1.84c.882-.543 1.593-1.076 2.134-1.6.54-.524.932-1.09 1.174-1.7.242-.609.363-1.326.363-2.15V3.633c0-.453-.104-.779-.312-.975a2.804 2.804 0 0 0-.834-.519 35.47 35.47 0 0 0-1.123-.429c-.515-.19-1.072-.39-1.674-.602A369.196 369.196 0 0 0 8.26.134a3.115 3.115 0 0 0-.369-.095A2.027 2.027 0 0 0 7.5 0c-.129 0-.26.017-.391.05a7.098 7.098 0 0 1-.37.084c-.234.06-.608.176-1.123.35-.514.176-1.072.372-1.673.592-.601.219-1.161.427-1.68.624-.518.197-.89.344-1.117.44a2.805 2.805 0 0 0-.834.518C.104 2.856 0 3.182 0 3.635v6.71c0 .825.121 1.542.363 2.152.242.609.634 1.175 1.174 1.7.541.523 1.25 1.056 2.128 1.599a60.71 60.71 0 0 0 3.234 1.84c.12.066.234.112.34.138.106.026.193.04.261.04Zm0-1.829a.768.768 0 0 1-.227-.039c-.083-.026-.2-.08-.352-.161a92.763 92.763 0 0 1-2.558-1.555c-.685-.435-1.228-.851-1.629-1.249a3.578 3.578 0 0 1-.862-1.304c-.174-.472-.26-1.046-.26-1.722v-6.02c0-.096.014-.172.045-.228.03-.055.09-.102.181-.139.363-.141.777-.292 1.243-.451.465-.16.945-.324 1.44-.491a100.8 100.8 0 0 0 1.436-.496c.461-.163.874-.316 1.237-.457a.85.85 0 0 1 .612 0c.363.141.774.295 1.231.463a168.653 168.653 0 0 0 2.86 1.014c.465.16.883.3 1.253.418.099.037.161.084.188.14a.54.54 0 0 1 .04.228v6.019c0 .676-.086 1.25-.256 1.722s-.456.907-.857 1.304c-.4.398-.943.814-1.628 1.249-.684.435-1.54.953-2.57 1.555a1.9 1.9 0 0 1-.34.161.768.768 0 0 1-.227.04Zm-.976-3.355c.34 0 .613-.156.817-.468l3.903-6.064c.06-.096.118-.199.17-.306a.76.76 0 0 0 .08-.34.63.63 0 0 0-.255-.53.92.92 0 0 0-.573-.195c-.28 0-.51.149-.692.446l-3.495 5.551L4.913 8.65a1.031 1.031 0 0 0-.363-.318.911.911 0 0 0-.386-.083.744.744 0 0 0-.556.234.773.773 0 0 0-.227.557c0 .216.076.42.227.613l2.043 2.508c.128.171.262.292.402.362.14.071.297.106.471.106Z",
    fill: "#555"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgConfirmed);

/***/ }),

/***/ 61686:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auctions",
      function () {
        return __webpack_require__(47518);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 96321:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/clock.b30d2d16.png","height":72,"width":72,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAG1BMVEUaoYZMaXEaoYYaoYYaoYYaoYYaoYYaoYYaoYaRdehPAAAACXRSTlNwAEsYgiQMAjozGGDOAAAACXBIWXMAACE4AAAhOAFFljFgAAAAMUlEQVQImR2LyQ3AQAyEwGf/HW+ckUB8Btd/rA2h2BVBiGRjzcVWkxh4nAvmwsnv/gAS+QCCJA2ouwAAAABJRU5ErkJggg=="});

/***/ }),

/***/ 74939:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/pin.0b606da5.png","height":72,"width":72,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAGFBMVEVMaXFUVFRUVFRUVFRUVFRUVFRUVFRUVFTKrMONAAAACHRSTlMAg0kYWDBnaULew2gAAAAJcEhZcwAAITgAACE4AUWWMWAAAAAuSURBVAiZRYrJDQAgEISY2cP+OzauMfLhAfCJXjWWrQCckhOodqZPU4XurVkeGw2XAFa9+KH7AAAAAElFTkSuQmCC"});

/***/ }),

/***/ 90117:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/star-empty.9b58e174.png","height":64,"width":66,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAKlBMVEVMaXH/1QD/1gD/1QD/1gD/1gD/1QD/1QD/1gD/1gD/1QD/1QD/1QD/1QDvucXGAAAADnRSTlMArGGUBzTVvxVFVHd5fIEpi/AAAAAJcEhZcwAAITgAACE4AUWWMWAAAAA3SURBVAiZFcZBEsAwCAOxtYFA0vb/3+3kJEESJgFm6XLc+5E3S0XWEqMCB/CezCggWmrffEyYHx0eANfrv9yhAAAAAElFTkSuQmCC"});

/***/ }),

/***/ 73223:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/star.65e3b886.png","height":64,"width":66,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAKlBMVEVMaXH/1QD/1QD/1gD/1QD/1gD/1QD/1QD/1QD/1QD/1QD/1QD/1QD/1gAMq7WQAAAADXRSTlMAk8EHY1xLEKHTYCZxg+IRYgAAAAlwSFlzAAAhOAAAITgBRZYxYAAAADVJREFUCJkdxskRwDAMw0BQkq8k7L/djIzPAhINEmA5mllh65kc3zYrWgHV8wLbcTwAfaSKHzLCAYGp1wV/AAAAAElFTkSuQmCC"});

/***/ }),

/***/ 26527:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/type.5049d419.png","height":72,"width":72,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAG1BMVEVMaXFUVFRUVFRUVFRUVFRUVFRUVFRUVFRUVFTwf7GUAAAACXRSTlMAc1WAPyqOG7UrjgUEAAAACXBIWXMAACE4AAAhOAFFljFgAAAALElEQVQImU2LuREAMAyDkPwk+0+ccxXTQAN8SpFj36IbSEnyjopQTIB91vsADWAAWboZdpgAAAAASUVORK5CYII="});

/***/ }),

/***/ 47518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ auctions_Auctions; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/intersection-observer/intersection-observer.js
var intersection_observer = __webpack_require__(18360);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(63964);
// EXTERNAL MODULE: ../../node_modules/tailwind-styled-components/dist/index.js
var dist = __webpack_require__(17471);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ../../node_modules/react-infinite-scroll-hook/dist/react-infinite-scroll-hook.esm.js + 1 modules
var react_infinite_scroll_hook_esm = __webpack_require__(93923);
// EXTERNAL MODULE: ../../node_modules/lodash/debounce.js
var debounce = __webpack_require__(54073);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ../../node_modules/next-i18next/dist/esm/index.js + 11 modules
var esm = __webpack_require__(33052);
// EXTERNAL MODULE: ../graphql/src/queries/Auctions.ts
var Auctions = __webpack_require__(77990);
// EXTERNAL MODULE: ../core/src/utils/index.ts
var utils = __webpack_require__(75920);
// EXTERNAL MODULE: ../core/src/contexts/AuctionList.tsx
var AuctionList = __webpack_require__(90755);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(94776);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
// EXTERNAL MODULE: ../../node_modules/luxon/build/cjs-browser/luxon.js
var luxon = __webpack_require__(96299);
// EXTERNAL MODULE: ../../node_modules/@material-ui/core/esm/Tooltip/Tooltip.js + 9 modules
var Tooltip = __webpack_require__(40864);
// EXTERNAL MODULE: ../graphql/src/generated/index.ts + 11 modules
var generated = __webpack_require__(63575);
// EXTERNAL MODULE: ../core/src/components/ActiveTag.tsx
var ActiveTag = __webpack_require__(77652);
// EXTERNAL MODULE: ../core/src/components/SvgIcon.tsx
var SvgIcon = __webpack_require__(16283);
// EXTERNAL MODULE: ../core/src/components/Countdown.tsx
var Countdown = __webpack_require__(699);
// EXTERNAL MODULE: ../assets/icons/pin.png
var pin = __webpack_require__(74939);
;// CONCATENATED MODULE: ../assets/icons/species.png
/* harmony default export */ var species = ({"src":"/_next/static/media/species.02433599.png","height":72,"width":72,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAFVBMVEVMaXFUVFRUVFRUVFRUVFRUVFRUVFRJ1bk/AAAAB3RSTlMAOGASgXKqFZKn9AAAAAlwSFlzAAAhOAAAITgBRZYxYAAAAChJREFUCJljYEAGjIwQipWVBcxgYWBmAjPYmJjAUswsEJqBmRlFIwMAB7kANmalNngAAAAASUVORK5CYII="});
// EXTERNAL MODULE: ../assets/icons/type.png
var type = __webpack_require__(26527);
// EXTERNAL MODULE: ../assets/icons/star.png
var star = __webpack_require__(73223);
// EXTERNAL MODULE: ../assets/icons/star-empty.png
var star_empty = __webpack_require__(90117);
;// CONCATENATED MODULE: ../assets/icons/card-chevron.svg
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgCardChevron = function SvgCardChevron(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    viewBox: "0 0 13 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "m1 1 10 10L1 21",
    stroke: "#AAA",
    strokeWidth: 2
  })));
};

/* harmony default export */ var card_chevron = (SvgCardChevron);
// EXTERNAL MODULE: ../assets/icons/confirmed.svg
var confirmed = __webpack_require__(83081);
;// CONCATENATED MODULE: ../core/src/components/AuctionCard.tsx






















function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "flex flex-1"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "items-center"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  flex-col\n  md:flex-row\n  rounded-md\n  bg-white\n  filter\n  overflow-hidden\n  transition-shadow\n  duration-300\n  group\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  flex\n  flex-1\n  flex-col\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  flex\n  flex-1\n  p-4\n  relative\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  flex\n  items-start\n  justify-start\n  min-w-[200px]\n  min-h-[200px]\n  h-full\n  relative\n  z-10\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "min-w-[150px] flex flex-col justify-start"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "text-gray-700 text-xs uppercase mb-1 whitespace-nowrap"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "text-black font-poppins text-lg"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "text-gray-700 text-sm"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "absolute z-[400] top-3 left-3"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  absolute\n  bottom-0\n  left-0\n  right-0\n  bg-black/50\n  flex\n  items-center\n  justify-center\n  h-8\n  z-[400]\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
var AuctionCardMap = (0,utils/* clientOnlyModule */.EG)(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9774), __webpack_require__.e(3164), __webpack_require__.e(5016), __webpack_require__.e(499), __webpack_require__.e(5318), __webpack_require__.e(4836), __webpack_require__.e(7236)]).then(__webpack_require__.bind(__webpack_require__, 87959));
});
var Line = dist_default().div(_templateObject());
var LineContainer = dist_default()(Line)(_templateObject1());
var CardContainer = dist_default()(Line)(_templateObject2(), function(param) {
    var $selected = param.$selected;
    return $selected ? 'shadow-hover z-10' : 'shadow';
});
var TextContainer = dist_default()(Line)(_templateObject3());
var InfoContainer = dist_default()(Line)(_templateObject4());
var MapContainer = dist_default().div(_templateObject5());
var PriceContainer = dist_default().div(_templateObject6());
var PriceTitle = dist_default().div(_templateObject7());
var Price = dist_default().div(_templateObject8());
var SmallText = dist_default().p(_templateObject9());
var StatusTag = dist_default()(ActiveTag/* ActiveTag */.M)(_templateObject10());
var ConfirmedContainer = dist_default().div(_templateObject11());
var AuctionCard = /*#__PURE__*/ (0,react.memo)(function(_param) {
    var id = _param.id, humanId = _param.humanId, title = _param.title, address = _param.address, endTime = _param.endTime, startingBid = _param.startingBid, highestBidObject = _param.highestBidObject, followed = _param.followed, owner = _param.owner, cadastralPlots = _param.cadastralPlots, forestType = _param.forestType, salePurpose = _param.salePurpose, forestInspected = _param.forestInspected, props = _objectWithoutProperties(_param, [
        "id",
        "humanId",
        "title",
        "address",
        "endTime",
        "startingBid",
        "highestBidObject",
        "followed",
        "owner",
        "cadastralPlots",
        "forestType",
        "salePurpose",
        "forestInspected"
    ]);
    (0,generated/* useBaseAuctionChangedSubscription */.oPU)({
        variables: {
            id: id
        }
    });
    var t = (0,esm/* useTranslation */.$G)([
        'auctions',
        'enum',
        'forest'
    ]).t;
    var ref = _slicedToArray((0,generated/* useFollowAuctionMutation */.hdy)(), 1), followAuctionMutation = ref[0];
    var ref1 = _slicedToArray((0,generated/* useUnfollowAuctionMutation */.wGk)(), 1), unfollowAuctionMutation = ref1[0];
    var ref2 = (0,react.useContext)(AuctionList/* default */.Z), selected = ref2.selected, setSelected = ref2.setSelected, currentUserId = ref2.currentUserId;
    var selectAuction = (0,react.useCallback)(function() {
        return setSelected(id);
    }, [
        setSelected,
        id
    ]);
    var deselectAuction = (0,react.useCallback)(function() {
        return setSelected(null);
    }, [
        setSelected
    ]);
    var onFollowClick = (0,react.useCallback)(function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(e) {
            var variables;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.preventDefault();
                        variables = {
                            input: {
                                auction: {
                                    id: id
                                }
                            }
                        };
                        if (!followed) {
                            _ctx.next = 7;
                            break;
                        }
                        _ctx.next = 5;
                        return unfollowAuctionMutation({
                            variables: variables
                        });
                    case 5:
                        _ctx.next = 9;
                        break;
                    case 7:
                        _ctx.next = 9;
                        return followAuctionMutation({
                            variables: variables
                        });
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(e) {
            return _ref.apply(this, arguments);
        };
    }(), [
        followed,
        id,
        unfollowAuctionMutation,
        followAuctionMutation
    ]);
    var active = luxon/* DateTime.fromISO */.ou.fromISO(endTime) > luxon/* DateTime.local */.ou.local();
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
        href: "/auctions/".concat(id),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: "flex",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContainer, _objectSpread({}, props, {
                $selected: selected === id,
                onMouseEnter: selectAuction,
                onMouseLeave: deselectAuction,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(MapContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AuctionCardMap, {
                                cadastralPlots: cadastralPlots
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StatusTag, {
                                active: active,
                                title: active ? t('common:auction.active') : t('common:auction.finished')
                            }),
                            forestInspected ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConfirmedContainer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* SvgIcon */.l, {
                                        src: confirmed/* default */.Z,
                                        inheritColors: true,
                                        useFill: true,
                                        size: 16,
                                        className: "mr-2 text-white"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-white text-sm",
                                        children: t('inspectedByForesters')
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextContainer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Line, {
                                        className: "flex-col md:flex-row mb-2 items-start md:items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "mr-4 mb-2 md:mb-auto font-poppins font-bold text-lg",
                                                children: title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "text-xs text-gray-700",
                                                children: [
                                                    "#",
                                                    humanId
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(LineContainer, {
                                        className: "mb-2 items-center space-x-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(LineContainer, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "flex mr-3 min-w-[24px]",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                                            src: pin/* default */.Z,
                                                            width: 24,
                                                            height: 24
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SmallText, {
                                                        children: address
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(LineContainer, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "flex mr-3 min-w-[24px]",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                                            src: type/* default */.Z,
                                                            width: 24,
                                                            height: 24
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SmallText, {
                                                        className: "flex-1",
                                                        children: t("enum:AuctionSalePurpose.".concat(salePurpose))
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(LineContainer, {
                                        className: "items-center space-x-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Countdown/* Countdown */.I, {
                                                endTime: endTime
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(LineContainer, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "flex mr-3 min-w-[24px]",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                                            src: species,
                                                            width: 24,
                                                            height: 24
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SmallText, {
                                                        children: t([
                                                            "enum:ForestType.".concat(forestType),
                                                            'forest:notSpecified'
                                                        ])
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Line, {
                                        className: "mb-5 pl-9 text-gray-700 text-sm",
                                        children: (0,utils/* endTimestamp */.mE)(endTime)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Line, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PriceContainer, {
                                                className: "mr-5 ",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceTitle, {
                                                        children: t('common:startingPrice')
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Price, {
                                                        children: (0,utils/* formatMoney */.lb)(startingBid)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PriceContainer, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceTitle, {
                                                        children: t('common:highestBid')
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Price, {
                                                        className: "font-semibold",
                                                        children: (0,utils/* formatMoney */.lb)(highestBidObject === null || highestBidObject === void 0 ? void 0 : highestBidObject.price)
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col justify-center items-center h-full w-[20px] overflow-visible hover:text-gray-700",
                                children: [
                                    currentUserId && currentUserId !== (owner === null || owner === void 0 ? void 0 : owner.id) && active && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute z-20 top-4 right-4 cursor-pointer",
                                        onClick: onFollowClick,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                                            title: followed ? t('unfollow') : t('follow'),
                                            placement: "top",
                                            arrow: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                                    src: followed ? star/* default */.Z : star_empty/* default */.Z,
                                                    width: 20,
                                                    height: 20
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* SvgIcon */.l, {
                                        inheritColors: true,
                                        src: card_chevron,
                                        width: 13,
                                        height: 22,
                                        className: "text-gray-500 group-hover:text-gray-700 p-2 -mr-2"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }))
        })
    }));
});


// EXTERNAL MODULE: ../core/src/components/Inputs/TextInput.tsx
var TextInput = __webpack_require__(10809);
// EXTERNAL MODULE: ../core/src/components/Inputs/CheckBox.tsx
var CheckBox = __webpack_require__(76008);
// EXTERNAL MODULE: ../core/src/components/Inputs/Select.tsx
var Select = __webpack_require__(41673);
// EXTERNAL MODULE: ../core/src/components/Spinner.tsx
var Spinner = __webpack_require__(60761);
// EXTERNAL MODULE: ../core/src/config/index.ts
var config = __webpack_require__(58451);
// EXTERNAL MODULE: ../core/src/config/domains.js
var domains = __webpack_require__(2811);
var domains_default = /*#__PURE__*/__webpack_require__.n(domains);
// EXTERNAL MODULE: ../core/src/components/Button.tsx
var Button = __webpack_require__(36573);
// EXTERNAL MODULE: ../core/src/components/CloseButton.tsx
var CloseButton = __webpack_require__(97872);
// EXTERNAL MODULE: ../core/src/components/ResponsiveImage.tsx
var ResponsiveImage = __webpack_require__(17094);
;// CONCATENATED MODULE: ../core/src/components/ActiveButton.tsx




function ActiveButton_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ActiveButton_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ActiveButton_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ActiveButton_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = ActiveButton_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function ActiveButton_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function ActiveButton_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ActiveButton_templateObject() {
    var data = ActiveButton_taggedTemplateLiteral([
        "\n  flex\n  items-center\n  box-border\n  px-5\n  h-8\n  md:h-11\n  rounded\n  transition\n  duration-300\n  border\n  ",
        "\n"
    ]);
    ActiveButton_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ActiveButton_templateObject1() {
    var data = ActiveButton_taggedTemplateLiteral([
        "\n  flex\n  ",
        "\n"
    ]);
    ActiveButton_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var BaseButton = dist_default().button(ActiveButton_templateObject(), function(param) {
    var $active = param.$active;
    return $active ? 'border-secondary-500' : 'border-gray-400';
});
var Title = dist_default().p(ActiveButton_templateObject1(), function(param) {
    var $active = param.$active;
    return $active ? 'text-primary-500' : 'text-gray-700';
});
var ActiveButton = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var img = _param.img, title = _param.title, active = _param.active, props = ActiveButton_objectWithoutProperties(_param, [
        "img",
        "title",
        "active"
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseButton, ActiveButton_objectSpread({
        $active: active,
        ref: ref
    }, props, {
        children: [
            img && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex mr-3",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveImage/* ResponsiveImage */.t, {
                    src: img,
                    sizes: [
                        16,
                        20
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                $active: active,
                children: title
            })
        ]
    })));
});


// EXTERNAL MODULE: ../core/src/components/Popup.tsx
var Popup = __webpack_require__(13788);
// EXTERNAL MODULE: ../core/src/hooks/index.ts
var hooks = __webpack_require__(32345);
;// CONCATENATED MODULE: ../core/src/components/PopupFilter.tsx









function PopupFilter_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function PopupFilter_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            PopupFilter_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function PopupFilter_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = PopupFilter_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function PopupFilter_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function PopupFilter_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function PopupFilter_templateObject() {
    var data = PopupFilter_taggedTemplateLiteral([
        "\n  absolute\n  top-3\n  right-2\n"
    ]);
    PopupFilter_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PopupFilter_templateObject1() {
    var data = PopupFilter_taggedTemplateLiteral([
        "cursor-pointer text-primary-500 underline"
    ]);
    PopupFilter_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var Close = dist_default()(CloseButton/* CloseButton */.P)(PopupFilter_templateObject());
var Clear = dist_default().span(PopupFilter_templateObject1());
var Content = function(param) {
    var onSave = param.onSave, onClear = param.onClear, close = param.close, children = param.children, title = param.title;
    var mobile = (0,hooks/* useDeviceMediaQuery */.mL)().mobile;
    var t = (0,esm/* useTranslation */.$G)().t;
    var handleSave = (0,react.useCallback)(function() {
        onSave();
        close();
    }, [
        onSave,
        close
    ]);
    var handleClear = (0,react.useCallback)(function() {
        onClear();
        close();
    }, [
        onClear,
        close
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: mobile ? 'w-min' : 'w-[420px]',
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Close, {
                onClick: close
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "p-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-sm mb-2",
                        children: title
                    }),
                    children
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "p-4 border-t-2 flex items-center justify-between space-x-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Clear, {
                        onClick: handleClear,
                        children: t('clear')
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        value: "save-filter",
                        title: t('save'),
                        onClick: handleSave
                    })
                ]
            })
        ]
    }));
};
var PopupFilter = function(_param) {
    var title = _param.title, icon = _param.icon, props = PopupFilter_objectWithoutProperties(_param, [
        "title",
        "icon"
    ]);
    var renderTrigger = (0,react.useCallback)(function(open) {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(ActiveButton, {
            title: title,
            img: icon,
            className: "mb-2 mr-4",
            active: open
        });
    }, [
        title,
        icon
    ]);
    var renderContent = (0,react.useCallback)(function(close) {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(Content, PopupFilter_objectSpread({
            close: close
        }, props, {
            title: title
        }));
    }, [
        props,
        title
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Popup/* Popup */.G, {
        trigger: renderTrigger,
        children: renderContent
    }));
};


;// CONCATENATED MODULE: ../core/src/components/AuctionList/PopupRangeFilter.tsx






function PopupRangeFilter_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function PopupRangeFilter_templateObject() {
    var data = PopupRangeFilter_taggedTemplateLiteral([
        "min-w-[120px]"
    ]);
    PopupRangeFilter_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var PopupInput = dist_default()(TextInput/* TextInput */.o)(PopupRangeFilter_templateObject());
var defaultState = [
    null,
    null
];
var PopupRangeFilter = function(param1) {
    var onChange = param1.onChange, min = param1.min, max = param1.max, title = param1.title, icon = param1.icon;
    var initialState = (0,react.useMemo)(function() {
        return [
            min,
            max
        ];
    }, [
        min,
        max
    ]);
    var t = (0,esm/* useTranslation */.$G)('common').t;
    var ref = (0,react.useState)(initialState), value = ref[0], setValue = ref[1];
    var onSave = (0,react.useCallback)(function() {
        return onChange(value);
    }, [
        onChange,
        value
    ]);
    var onClear = (0,react.useCallback)(function() {
        setValue(defaultState);
        onChange(defaultState);
    }, [
        onChange,
        setValue
    ]);
    var setMinValue = (0,react.useCallback)(function(param) {
        var target = param.target;
        var minValue = parseFloat(target.value);
        setValue([
            isNaN(minValue) ? null : minValue,
            value[1]
        ]);
    }, [
        setValue,
        value
    ]);
    var setMaxValue = (0,react.useCallback)(function(param) {
        var target = param.target;
        var maxValue = parseFloat(target.value);
        setValue([
            value[0],
            isNaN(maxValue) ? null : maxValue
        ]);
    }, [
        setValue,
        value
    ]);
    var ref1, ref2;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(PopupFilter, {
        icon: icon,
        title: title,
        onSave: onSave,
        onClear: onClear,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex space-x-4",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupInput, {
                    name: "".concat(title, "-min"),
                    label: t('min'),
                    type: "number",
                    defaultValue: (ref1 = value[0]) !== null && ref1 !== void 0 ? ref1 : '',
                    onChange: setMinValue
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupInput, {
                    name: "".concat(title, "-max"),
                    label: t('max'),
                    type: "number",
                    defaultValue: (ref2 = value[1]) !== null && ref2 !== void 0 ? ref2 : '',
                    onChange: setMaxValue
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ../core/src/components/MultiSelectList.tsx




function MultiSelectList_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return MultiSelectList_arrayLikeToArray(arr);
}
function MultiSelectList_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function MultiSelectList_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            MultiSelectList_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function MultiSelectList_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = MultiSelectList_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function MultiSelectList_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function MultiSelectList_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || MultiSelectList_unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function MultiSelectList_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return MultiSelectList_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return MultiSelectList_arrayLikeToArray(o, minLen);
}
function MultiSelectList_templateObject() {
    var data = MultiSelectList_taggedTemplateLiteral([
        "flex flex-col space-y-4"
    ]);
    MultiSelectList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var Container = dist_default().div(MultiSelectList_templateObject());
var Item = function(param) {
    var label = param.label, value = param.value, onChange = param.onChange, selected = param.selected;
    var handleChange = (0,react.useCallback)(function() {
        return onChange(value);
    }, [
        onChange,
        value
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(CheckBox/* CheckBox */.J, {
        name: value,
        label: label,
        checked: selected,
        onChange: handleChange
    }));
};
var MultiSelectList = function(_param) {
    var options = _param.options, selected = _param.selected, onChange = _param.onChange, props = MultiSelectList_objectWithoutProperties(_param, [
        "options",
        "selected",
        "onChange"
    ]);
    var handleChange = (0,react.useCallback)(function(value) {
        var values = selected.includes(value) ? selected.filter(function(item) {
            return item !== value;
        }) : _toConsumableArray(selected).concat([
            value
        ]);
        onChange(values);
    }, [
        onChange,
        selected
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Container, MultiSelectList_objectSpread({}, props, {
        children: options.map(function(param) {
            var label = param.label, value = param.value;
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(Item, {
                onChange: handleChange,
                label: label,
                value: value,
                selected: selected.includes(value)
            }, value);
        })
    })));
};


;// CONCATENATED MODULE: ../core/src/components/AuctionList/PopupMultiSelectFilter.tsx




function PopupMultiSelectFilter_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function PopupMultiSelectFilter_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            PopupMultiSelectFilter_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function PopupMultiSelectFilter_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = PopupMultiSelectFilter_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function PopupMultiSelectFilter_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var PopupMultiSelectFilter_defaultState = [];
var PopupMultiSelectFilter = function(_param) {
    var onChange = _param.onChange, _defaultValue = _param.defaultValue, defaultValue = _defaultValue === void 0 ? PopupMultiSelectFilter_defaultState : _defaultValue, title = _param.title, props = PopupMultiSelectFilter_objectWithoutProperties(_param, [
        "onChange",
        "defaultValue",
        "title"
    ]);
    var ref = (0,react.useState)(defaultValue !== null && defaultValue !== void 0 ? defaultValue : PopupMultiSelectFilter_defaultState), selected = ref[0], setSelected = ref[1];
    var onSave = (0,react.useCallback)(function() {
        return onChange(selected);
    }, [
        onChange,
        selected
    ]);
    var onClear = (0,react.useCallback)(function() {
        setSelected(PopupMultiSelectFilter_defaultState);
        onChange(PopupMultiSelectFilter_defaultState);
    }, [
        onChange
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(PopupFilter, {
        title: title,
        onSave: onSave,
        onClear: onClear,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiSelectList, PopupMultiSelectFilter_objectSpread({
            className: "mt-4"
        }, props, {
            selected: selected,
            onChange: setSelected
        }))
    }));
};


;// CONCATENATED MODULE: ../core/src/components/AuctionList/utils.ts


function utils_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function utils_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function utils_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function utils_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function utils_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function utils_slicedToArray(arr, i) {
    return utils_arrayWithHoles(arr) || utils_iterableToArrayLimit(arr, i) || utils_unsupportedIterableToArray(arr, i) || utils_nonIterableRest();
}
function utils_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return utils_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return utils_arrayLikeToArray(o, minLen);
}
var defaultFilterProps = {
    price: {
        min: null,
        max: null
    },
    area: {
        min: null,
        max: null
    },
    volume: {
        min: null,
        max: null
    },
    forestType: {
        options: (0,utils/* enumToOption */.$1)(generated/* ForestType */.dDq)
    },
    salePurpose: {
        options: (0,utils/* enumToOption */.$1)(generated/* AuctionSalePurpose */.QKG)
    },
    maturity: {
        options: (0,utils/* enumToOption */.$1)(generated/* TaxonomicPlotMaturityCondition */.CzM)
    },
    country: {
        options: (0,utils/* enumToOption */.$1)(generated/* AuctionCountryCode */.naz)
    }
};
var filterStateToQueryVariables = function(param1) {
    var price = param1.price, area = param1.area, volume = param1.volume, forestTypeIn = param1.forestType, salePurposeIn = param1.salePurpose, maturityIn = param1.maturity, sortOrder = param1.sortOrder, countryCodeIn = param1.country;
    var ref;
    var ref1 = utils_slicedToArray((ref = price === null || price === void 0 ? void 0 : price.map(function(value) {
        return value ? value * 100 : value;
    })) !== null && ref !== void 0 ? ref : [], 2), priceCentsGteq = ref1[0], priceCentsLteq = ref1[1];
    var ref2 = utils_slicedToArray(area !== null && area !== void 0 ? area : [], 2), areaGteq = ref2[0], areaLteq = ref2[1];
    var ref3 = utils_slicedToArray(volume !== null && volume !== void 0 ? volume : [], 2), volumeGteq = ref3[0], volumeLteq = ref3[1];
    var order;
    if (sortOrder) {
        var ref4 = utils_slicedToArray(sortOrder.value.split('/'), 2), property = ref4[0], direction = ref4[1];
        order = utils_defineProperty({}, property, direction);
    }
    return Object.fromEntries(Object.entries({
        priceCentsGteq: priceCentsGteq,
        priceCentsLteq: priceCentsLteq,
        areaGteq: areaGteq,
        areaLteq: areaLteq,
        volumeGteq: volumeGteq,
        volumeLteq: volumeLteq,
        forestTypeIn: forestTypeIn,
        salePurposeIn: salePurposeIn,
        maturityIn: maturityIn,
        order: order,
        countryCodeIn: countryCodeIn
    }).filter(function(param) {
        var _param = utils_slicedToArray(param, 2), value = _param[1];
        return typeof value !== 'undefined';
    }));
};

;// CONCATENATED MODULE: ../assets/icons/area-icon.png
/* harmony default export */ var area_icon = ({"src":"/_next/static/media/area-icon.4f1add8b.png","height":78,"width":78,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAHlBMVEVMaXEAQFEAQVEAQFEAQFEAQFEAQFEAQFEAQFEAQFHbi1DbAAAACnRSTlMAmAZjhqkfRW8r+/ArWQAAAAlwSFlzAAAhOAAAITgBRZYxYAAAAC9JREFUCJlFh8kJADAQhJw9k/4bDvOKCCJ8RhVu9t1e6OOTqBq4StjOo4EgKh1rHhN0AInEcbnkAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ../assets/icons/price.png
/* harmony default export */ var price = ({"src":"/_next/static/media/price.35762acb.png","height":78,"width":78,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAHlBMVEVMaXEAQFEAQFEAQFEAQFEAQFEAQFEAQFEAQFEAQFFA+LoPAAAACnRSTlMADnWDlx5bRNe2vntLpwAAAAlwSFlzAAAhOAAAITgBRZYxYAAAADBJREFUCJlNi0kOACAMAmmhi///sKkxUS4MmQC8GOXTsRRlANiMY7x9NgCpLibz+24PsABrvgbMqQAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ../core/src/components/AuctionList/index.tsx






















function AuctionList_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function AuctionList_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function AuctionList_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function AuctionList_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function AuctionList_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function AuctionList_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            AuctionList_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function AuctionList_slicedToArray(arr, i) {
    return AuctionList_arrayWithHoles(arr) || AuctionList_iterableToArrayLimit(arr, i) || AuctionList_unsupportedIterableToArray(arr, i) || AuctionList_nonIterableRest();
}
function AuctionList_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function AuctionList_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return AuctionList_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return AuctionList_arrayLikeToArray(o, minLen);
}
function AuctionList_templateObject() {
    var data = AuctionList_taggedTemplateLiteral([
        "\n  flex\n  flex-1\n"
    ]);
    AuctionList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AuctionList_templateObject1() {
    var data = AuctionList_taggedTemplateLiteral([
        "\n  w-screen\n  flex-col-reverse\n  lg:flex-row\n"
    ]);
    AuctionList_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function AuctionList_templateObject2() {
    var data = AuctionList_taggedTemplateLiteral([
        "flex flex-col w-full lg:w-2/3 p-6 md:pt-16"
    ]);
    AuctionList_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function AuctionList_templateObject3() {
    var data = AuctionList_taggedTemplateLiteral([
        "\n  flex\n  flex-col\n  lg:flex-row\n  items-start\n  lg:items-center\n  justify-between\n  flex-wrap\n  mb-5\n"
    ]);
    AuctionList_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function AuctionList_templateObject4() {
    var data = AuctionList_taggedTemplateLiteral([
        "flex-col space-y-8 mb-4"
    ]);
    AuctionList_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function AuctionList_templateObject5() {
    var data = AuctionList_taggedTemplateLiteral([
        "\n  flex-col\n  space-y-5\n"
    ]);
    AuctionList_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function AuctionList_templateObject6() {
    var data = AuctionList_taggedTemplateLiteral([
        "\n  h-[420px]\n  lg:h-screen\n  w-full\n  lg:w-1/3\n  lg:sticky\n  top-0\n  right-0\n  border-l\n  z-50\n  border-gray-400\n"
    ]);
    AuctionList_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function AuctionList_templateObject7() {
    var data = AuctionList_taggedTemplateLiteral([
        "flex-col items-center justify-center"
    ]);
    AuctionList_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function AuctionList_templateObject8() {
    var data = AuctionList_taggedTemplateLiteral([
        "flex flex-wrap"
    ]);
    AuctionList_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function AuctionList_templateObject9() {
    var data = AuctionList_taggedTemplateLiteral([
        "\n  max-width: 370px;\n  min-width: 195px;\n  margin-right: 10px;\n"
    ]);
    AuctionList_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
var AuctionListMap = (0,utils/* clientOnlyModule */.EG)(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9774), __webpack_require__.e(3164), __webpack_require__.e(5016), __webpack_require__.e(499), __webpack_require__.e(5318), __webpack_require__.e(6426), __webpack_require__.e(4836), __webpack_require__.e(4784), __webpack_require__.e(9957)]).then(__webpack_require__.bind(__webpack_require__, 37839));
});
var Flex1 = dist_default().div(AuctionList_templateObject());
var AuctionList_Container = dist_default()(Flex1)(AuctionList_templateObject1());
var ListContainer = dist_default().div(AuctionList_templateObject2());
var TitleContainer = dist_default().div(AuctionList_templateObject3());
var List = dist_default()(Flex1)(AuctionList_templateObject4());
var CardsContainer = dist_default()(Flex1)(AuctionList_templateObject5());
var AuctionList_MapContainer = dist_default().div(AuctionList_templateObject6());
var MessageContainer = dist_default()(Flex1)(AuctionList_templateObject7());
var AuctionList_LineContainer = dist_default().div(AuctionList_templateObject8());
var StyledTextInput = (0,styled_components_browser_esm/* default */.ZP)(TextInput/* TextInput */.o).withConfig({
    componentId: "sc-282002d6-0"
})(AuctionList_templateObject9());
var AuctionList_AuctionList = (0,utils/* clientOnlyComponent */.V4)(function() {
    var t = (0,esm/* useTranslation */.$G)([
        'auctions',
        'enum'
    ]).t;
    var options = (0,react.useMemo)(function() {
        return [
            {
                value: 'relevance/desc',
                label: t('sorts.relevanceDescending')
            },
            {
                value: 'currentBidPrice/asc',
                label: t('sorts.priceAscending')
            },
            {
                value: 'currentBidPrice/desc',
                label: t('sorts.priceDescending')
            },
            {
                value: 'endTime/desc',
                label: t('sorts.endTimeDescending')
            },
            {
                value: 'endTime/asc',
                label: t('sorts.endTimeAscending')
            },
            {
                value: 'startTime/desc',
                label: t('sorts.startTimeDescending')
            },
            {
                value: 'timesViewed/desc',
                label: t('sorts.viewsDescending')
            }, 
        ];
    }, [
        t
    ]);
    var filterProps = (0,react.useMemo)(function() {
        return AuctionList_objectSpread({}, defaultFilterProps, {
            forestType: {
                options: defaultFilterProps.forestType.options.map(function(param) {
                    var label = param.label, value = param.value;
                    return {
                        label: t("enum:ForestType.".concat(label)),
                        value: value
                    };
                })
            },
            salePurpose: {
                options: defaultFilterProps.salePurpose.options.map(function(param) {
                    var label = param.label, value = param.value;
                    return {
                        label: t("enum:AuctionSalePurpose.".concat(label)),
                        value: value
                    };
                })
            },
            maturity: {
                options: defaultFilterProps.maturity.options.map(function(param) {
                    var label = param.label, value = param.value;
                    return {
                        label: t("enum:TaxonomicPlotMaturityCondition.".concat(label)),
                        value: value
                    };
                })
            },
            country: {
                options: defaultFilterProps.country.options.map(function(param) {
                    var label = param.label, value = param.value;
                    return {
                        label: t("enum:CountryCode.".concat(label)),
                        value: value
                    };
                })
            }
        });
    }, [
        t
    ]);
    var initialSortOption = options[4];
    var initialQueryVariables = (0,react.useMemo)(function() {
        var _current = (domains_default()).current, name = _current.name, countryCode = _current.countryCode;
        return AuctionList_objectSpread({
            auctionOpen: true
        }, filterStateToQueryVariables({
            sortOrder: initialSortOption,
            country: name === 'foros.lv' ? [
                countryCode
            ] : undefined
        }));
    }, [
        initialSortOption
    ]);
    var savedQueryVariables = JSON.parse(sessionStorage.getItem(config/* auctionsFilterKey */.PV) || '{}');
    var ref = (0,react.useState)(AuctionList_objectSpread({}, initialQueryVariables, savedQueryVariables)), queryVariables = ref[0], setQueryVariables = ref[1];
    var ref1 = (0,Auctions/* usePaginatedListAuctionsQuery */.N)(queryVariables), data = ref1.data, loading = ref1.loading, fetchMore = ref1.fetchMore, hasNextPage = ref1.hasNextPage;
    var ref2 = AuctionList_slicedToArray((0,react_infinite_scroll_hook_esm/* default */.Z)({
        loading: loading,
        hasNextPage: hasNextPage,
        onLoadMore: function() {
            return fetchMore(queryVariables);
        }
    }), 1), sentryRef = ref2[0];
    var handleFilterChange = (0,react.useCallback)(function(changedQueryVariables) {
        return setQueryVariables(AuctionList_objectSpread({}, queryVariables, changedQueryVariables));
    }, [
        queryVariables
    ]);
    var createFilterHandler = (0,react.useCallback)(function(name) {
        return function(value) {
            return handleFilterChange(filterStateToQueryVariables(AuctionList_defineProperty({}, name, value)));
        };
    }, [
        handleFilterChange
    ]);
    var handleInputChange = debounce_default()(function(param) {
        var target = param.target;
        return handleFilterChange(AuctionList_defineProperty({}, target.name, target.value));
    }, 500);
    var handleCheckboxChange = (0,react.useCallback)(function(param) {
        var target = param.target;
        var checked = target.checked;
        handleFilterChange(AuctionList_objectSpread({}, filterStateToQueryVariables({
            sortOrder: checked ? initialSortOption : options[0]
        }), AuctionList_defineProperty({}, target.name, checked ? true : null)));
    }, [
        handleFilterChange,
        options,
        initialSortOption
    ]);
    var handleSelectChange = (0,react.useCallback)(function(option, param) {
        var name = param.name;
        return handleFilterChange(filterStateToQueryVariables(AuctionList_defineProperty({}, name, option)));
    }, [
        handleFilterChange
    ]);
    (0,react.useEffect)(function() {
        sessionStorage.setItem(config/* auctionsFilterKey */.PV, JSON.stringify(queryVariables));
    }, [
        queryVariables
    ]);
    var auctions = (0,react.useMemo)(function() {
        return data === null || data === void 0 ? void 0 : data.auctions.edges.map(function(param) {
            var node = param.node;
            return node;
        });
    }, [
        data
    ]);
    var sortOption = (0,react.useMemo)(function() {
        var order = queryVariables.order;
        if (order) {
            var optionValue = Object.entries(order)[0].join('/');
            return options.find(function(param) {
                var value = param.value;
                return value === optionValue;
            });
        }
        return initialSortOption;
    }, [
        options,
        initialSortOption,
        queryVariables
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(AuctionList/* AuctionListContextProvider */.i, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AuctionList_Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TitleContainer, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mb-4 lg:mb-0 font-poppins font-bold text-4xl",
                                    children: t('title')
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckBox/* CheckBox */.J, {
                                    name: "auctionOpen",
                                    label: t('showOnlyOpenAuctions'),
                                    onChange: handleCheckboxChange,
                                    defaultChecked: !!queryVariables.auctionOpen
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(List, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(AuctionList_LineContainer, {
                                    className: "-mb-2 -mr-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupRangeFilter, AuctionList_objectSpread({
                                            title: t('price'),
                                            onChange: createFilterHandler('price'),
                                            icon: price
                                        }, filterProps.price, {
                                            min: queryVariables['priceCentsGteq'],
                                            max: queryVariables['priceCentsLteq']
                                        })),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupRangeFilter, AuctionList_objectSpread({
                                            title: t('area'),
                                            onChange: createFilterHandler('area'),
                                            icon: area_icon
                                        }, filterProps.area, {
                                            min: queryVariables['areaGteq'],
                                            max: queryVariables['areaLteq']
                                        })),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupRangeFilter, AuctionList_objectSpread({
                                            title: t('volume'),
                                            onChange: createFilterHandler('volume')
                                        }, filterProps.volume, {
                                            min: queryVariables['volumeGteq'],
                                            max: queryVariables['volumeLteq']
                                        })),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupMultiSelectFilter, AuctionList_objectSpread({
                                            title: t('forestType'),
                                            onChange: createFilterHandler('forestType'),
                                            defaultValue: queryVariables['forestTypeIn']
                                        }, filterProps.forestType)),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupMultiSelectFilter, AuctionList_objectSpread({
                                            title: t('salePurpose'),
                                            onChange: createFilterHandler('salePurpose'),
                                            defaultValue: queryVariables['salePurposeIn']
                                        }, filterProps.salePurpose)),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupMultiSelectFilter, AuctionList_objectSpread({
                                            title: t('maturity'),
                                            onChange: createFilterHandler('maturity'),
                                            defaultValue: queryVariables['maturityIn']
                                        }, filterProps.maturity)),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupMultiSelectFilter, AuctionList_objectSpread({
                                            title: t('country'),
                                            onChange: createFilterHandler('country'),
                                            defaultValue: queryVariables['countryCodeIn']
                                        }, filterProps.country))
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(AuctionList_LineContainer, {
                                    className: "items-end",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex flex-1 items-end",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTextInput, {
                                                name: "titleCont",
                                                label: t('keywordSearch'),
                                                onChange: handleInputChange,
                                                defaultValue: queryVariables['titleCont']
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* Select */.P, {
                                            name: "sortOrder",
                                            label: t('sortOrder'),
                                            options: options,
                                            className: "lg:ml-40",
                                            onChange: handleSelectChange,
                                            value: sortOption
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardsContainer, {
                                    children: [
                                        loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* Spinner */.$, {}) : null,
                                        (auctions === null || auctions === void 0 ? void 0 : auctions.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                auctions.map(function(auction) {
                                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(AuctionCard, AuctionList_objectSpread({}, auction), auction.id);
                                                }),
                                                hasNextPage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* Spinner */.$, {
                                                    ref: sentryRef
                                                }) : null
                                            ]
                                        }) : loading ? null : /*#__PURE__*/ (0,jsx_runtime.jsxs)(MessageContainer, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "font-semibold text-xl",
                                                    children: t('common:noResultsFound')
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-gray-700",
                                                    children: t('tryDifferentCriteria')
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AuctionList_MapContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuctionListMap, {
                        auctions: data === null || data === void 0 ? void 0 : data.filteredAuctions.nodes,
                        disableFallback: true
                    })
                })
            ]
        })
    }));
});

// EXTERNAL MODULE: ../core/src/components/Navigation/NavBar.tsx + 7 modules
var NavBar = __webpack_require__(42234);
// EXTERNAL MODULE: ../core/src/components/Navigation/Footer.tsx
var Footer = __webpack_require__(41347);
;// CONCATENATED MODULE: ./src/pages/auctions/index.tsx


var __N_SSG = true;
function auctions_Auctions() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NavBar/* NavBar */.l, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AuctionList_AuctionList, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* Footer */.$, {})
        ]
    }));
};


/***/ }),

/***/ 77652:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ ActiveTag; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var tailwind_styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17471);
/* harmony import */ var tailwind_styled_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(tailwind_styled_components__WEBPACK_IMPORTED_MODULE_1__);


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  inline-block\n  px-2\n  py-[5px]\n  rounded\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  font-bold\n  text-xs\n  uppercase\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var TagContainer = tailwind_styled_components__WEBPACK_IMPORTED_MODULE_1___default().div(_templateObject(), function(param) {
    var $active = param.$active;
    return $active ? 'bg-green-100' : 'bg-red-100';
});
var TagTitle = tailwind_styled_components__WEBPACK_IMPORTED_MODULE_1___default().p(_templateObject1(), function(param) {
    var $active = param.$active;
    return $active ? 'text-green-500 animate-pulse' : 'text-red-500';
});
var ActiveTag = function(_param) {
    var title = _param.title, active = _param.active, props = _objectWithoutProperties(_param, [
        "title",
        "active"
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TagContainer, _objectSpread({
        $active: active
    }, props, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TagTitle, {
            $active: active,
            children: title
        })
    })));
};



/***/ }),

/***/ 699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ Countdown; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var tailwind_styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17471);
/* harmony import */ var tailwind_styled_components__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(tailwind_styled_components__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96577);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32345);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(75920);
/* harmony import */ var _foros_fe_assets_icons_clock_png__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96321);







function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "flex flex-1 items-center"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "flex mr-3 min-w-[24px]"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "text-green-500 text-sm"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
var Container = tailwind_styled_components__WEBPACK_IMPORTED_MODULE_2___default().div(_templateObject());
var ImgContainer = tailwind_styled_components__WEBPACK_IMPORTED_MODULE_2___default().div(_templateObject1());
var Text = tailwind_styled_components__WEBPACK_IMPORTED_MODULE_2___default().p(_templateObject2());
var Countdown = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(function(param) {
    var className = param.className, endTime = param.endTime, _showTimestamp = param.showTimestamp, showTimestamp = _showTimestamp === void 0 ? false : _showTimestamp;
    var time = (0,_hooks__WEBPACK_IMPORTED_MODULE_5__/* .useDateTimeDuration */ .$o)(endTime);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Container, {
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ImgContainer, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_3__["default"], {
                    src: _foros_fe_assets_icons_clock_png__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,
                    width: 24,
                    height: 24
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Text, {
                children: [
                    time,
                    showTimestamp ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        className: "text-gray-700",
                        children: [
                            " [",
                            (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .endTimestamp */ .mE)(endTime),
                            "]"
                        ]
                    }) : null
                ]
            })
        ]
    }));
});


/***/ }),

/***/ 41673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ Select; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_select__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29982);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63964);
/* harmony import */ var tailwind_styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17471);
/* harmony import */ var tailwind_styled_components__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(tailwind_styled_components__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46487);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33052);







function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  flex\n  flex-col\n  flex-1\n  text-left\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  & .Select__control {\n    background-color: ",
        ";\n    border-color: ",
        ";\n    display: flex;\n    flex: 1;\n    box-shadow: none !important;\n    height: 44px;\n    border-radius: 8px;\n\n    @media (max-width: 768px) {\n      height: 40px;\n    }\n  }\n\n  & .Select__control--is-focused,\n  & .Select__control--menu-is-open {\n    border-color: ",
        " !important;\n  }\n\n  & .Select__control:hover {\n    background-color: ",
        ";\n    border-color: ",
        ";\n    width: 100%;\n  }\n\n  & .Select__single-value {\n    color: ",
        ";\n  }\n\n  & .Select__placeholder {\n    color: ",
        ";\n  }\n\n  & .Select__indicator-separator {\n    display: none;\n  }\n\n  & .Select__indicator Select__dropdown-indicator {\n    border-color: transparent transparent red;\n  }\n\n  & .Select__menu {\n    z-index: 100;\n  }\n\n  & .Select__option {\n    color: ",
        ";\n\n    & :hover {\n      background-color: ",
        ";\n    }\n  }\n\n  & .Select__option--is-selected {\n    background-color: ",
        ";\n\n    & :hover {\n      background-color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var Container = tailwind_styled_components__WEBPACK_IMPORTED_MODULE_2___default().div(_templateObject());
var StyledSelect = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(react_select__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP).withConfig({
    componentId: "sc-a70c89b9-0"
})(_templateObject1(), (_config__WEBPACK_IMPORTED_MODULE_6___default().colors.white), (_config__WEBPACK_IMPORTED_MODULE_6___default().colors.gray[400]), (_config__WEBPACK_IMPORTED_MODULE_6___default().colors.secondary[500]), (_config__WEBPACK_IMPORTED_MODULE_6___default().colors.white), (_config__WEBPACK_IMPORTED_MODULE_6___default().colors.gray[400]), (_config__WEBPACK_IMPORTED_MODULE_6___default().colors.gray[800]), (_config__WEBPACK_IMPORTED_MODULE_6___default().colors.gray[600]), (_config__WEBPACK_IMPORTED_MODULE_6___default().colors.primary[500]), (_config__WEBPACK_IMPORTED_MODULE_6___default().colors.gray[300]), (_config__WEBPACK_IMPORTED_MODULE_6___default().colors.gray[300]), (_config__WEBPACK_IMPORTED_MODULE_6___default().colors.gray[400]));
var GenericSelect = function(_param, ref1) {
    var label = _param.label, className = _param.className, props = _objectWithoutProperties(_param, [
        "label",
        "className"
    ]);
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)('common').t;
    var selectRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useImperativeHandle)(ref1, function() {
        return {
            focus: function() {
                var ref;
                return (ref = selectRef.current) === null || ref === void 0 ? void 0 : ref.focus();
            }
        };
    }, [
        selectRef
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Container, {
        className: className,
        children: [
            label ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                className: "text-sm mb-1 md:mb-2 font-semibold text-gray-800",
                children: label
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledSelect, _objectSpread({
                instanceId: label,
                classNamePrefix: "Select",
                isSearchable: false,
                placeholder: t('choose'),
                openMenuOnFocus: true,
                ref: selectRef
            }, props))
        ]
    }));
};
var Select = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(GenericSelect);


/***/ }),

/***/ 41347:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ Footer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var tailwind_styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17471);
/* harmony import */ var tailwind_styled_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(tailwind_styled_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33052);
/* harmony import */ var _NavLink__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72499);




function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "container flex flex-col md:flex-row py-6 gap-8"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "text-sm text-gray-700"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var Container = tailwind_styled_components__WEBPACK_IMPORTED_MODULE_1___default().div(_templateObject());
var Copyright = tailwind_styled_components__WEBPACK_IMPORTED_MODULE_1___default().p(_templateObject1());
var Footer = function() {
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "bg-white border-t border-gray-300",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Container, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex gap-8",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Copyright, {
                            children: t('copyright')
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_NavLink__WEBPACK_IMPORTED_MODULE_3__/* .NavLink */ .O, {
                            href: "/rules",
                            children: t('nav.rules')
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex mt-3 md:mt-0 gap-8",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_NavLink__WEBPACK_IMPORTED_MODULE_3__/* .NavLink */ .O, {
                            href: "/privacy-policy",
                            children: t('nav.privacyPolicy')
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_NavLink__WEBPACK_IMPORTED_MODULE_3__/* .NavLink */ .O, {
                            href: "/about-us",
                            children: t('nav.aboutUs')
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_NavLink__WEBPACK_IMPORTED_MODULE_3__/* .NavLink */ .O, {
                            href: "/contact-us",
                            children: t('nav.contactUs')
                        })
                    ]
                })
            ]
        })
    }));
};


/***/ }),

/***/ 17094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ ResponsiveImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75920);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96577);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32345);




function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var ResponsiveImage = (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .clientOnlyComponent */ .V4)(function(_param) {
    var sizes = _param.sizes, widths = _param.widths, heights = _param.heights, props = _objectWithoutProperties(_param, [
        "sizes",
        "widths",
        "heights"
    ]);
    var mobile = (0,_hooks__WEBPACK_IMPORTED_MODULE_3__/* .useDeviceMediaQuery */ .mL)().mobile;
    var ref = _slicedToArray(widths !== null && widths !== void 0 ? widths : sizes, 2), mobileWidth = ref[0], desktopWidth = ref[1];
    var ref1 = _slicedToArray(heights !== null && heights !== void 0 ? heights : sizes, 2), mobileHeight = ref1[0], desktopHeight = ref1[1];
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_1__["default"], _objectSpread({}, props, {
        width: mobile ? mobileWidth : desktopWidth,
        height: mobile ? mobileHeight : desktopHeight
    })));
});



/***/ }),

/***/ 60761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ Spinner; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63964);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46487);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_1__);


function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  align-self: center;\n  width: 44px;\n  height: 44px;\n  border: 4px ",
        " solid;\n  border-top: 4px ",
        " solid;\n  border-radius: 50%;\n  -webkit-animation: spCircRot 0.6s infinite linear;\n  animation: spCircRot 0.6s infinite linear;\n\n  @-webkit-keyframes spCircRot {\n    from {\n      -webkit-transform: rotate(0deg);\n    }\n    to {\n      -webkit-transform: rotate(359deg);\n    }\n  }\n  @keyframes spCircRot {\n    from {\n      transform: rotate(0deg);\n    }\n    to {\n      transform: rotate(359deg);\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var Spinner = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-a15f7bb9-0"
})(_templateObject(), (_config__WEBPACK_IMPORTED_MODULE_1___default().colors.gray[400]), (_config__WEBPACK_IMPORTED_MODULE_1___default().colors.secondary[500]));


/***/ }),

/***/ 90755:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ AuctionListContextProvider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _foros_fe_graphql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63575);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var initialState = {
    selected: null,
    setSelected: function() {},
    currentUserId: undefined
};
var Context = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(initialState);
/* harmony default export */ __webpack_exports__["Z"] = (Context);
var AuctionListContextProvider = function(param) {
    var children = param.children;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(initialState), state1 = ref1[0], setState = ref1[1];
    var data = (0,_foros_fe_graphql__WEBPACK_IMPORTED_MODULE_2__/* .useCurrentUserQuery */ .rkO)({
        fetchPolicy: 'cache-first'
    }).data;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setState(function(state) {
            var ref;
            return _objectSpread({}, state, {
                currentUserId: data === null || data === void 0 ? void 0 : (ref = data.currentUser) === null || ref === void 0 ? void 0 : ref.id
            });
        });
    }, [
        data
    ]);
    var value = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return _objectSpread({}, state1, {
            setSelected: function(selected) {
                return setState(_objectSpread({}, state1, {
                    selected: selected
                }));
            }
        });
    }, [
        state1
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Context.Provider, {
        value: value,
        children: children
    }));
};


/***/ }),

/***/ 77990:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ usePaginatedListAuctionsQuery; },
/* harmony export */   "D": function() { return /* binding */ usePaginatedBaseMarketAuctionQuery; }
/* harmony export */ });
/* harmony import */ var _generated__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63575);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33627);


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var PER_PAGE = 10;
var usePaginatedListAuctionsQuery = function(variables) {
    return (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .usePaginatedQuery */ .N)(_generated__WEBPACK_IMPORTED_MODULE_1__/* .useListAuctionsQuery */ .e5v, {
        variables: _objectSpread({
            first: PER_PAGE
        }, variables),
        nextFetchPolicy: 'cache-only'
    }, 'auctions');
};
var usePaginatedBaseMarketAuctionQuery = function(variables) {
    return (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .usePaginatedQuery */ .N)(_generated__WEBPACK_IMPORTED_MODULE_1__/* .useBaseMarketAuctionsQuery */ .fSg, {
        variables: _objectSpread({
            first: PER_PAGE
        }, variables),
        fetchPolicy: 'cache-first'
    }, 'marketAuctions');
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7362,1433,9982,864,5289,3442,2234,9774,2888,179], function() { return __webpack_exec__(61686); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);